import { State } from '@progress/kendo-data-query';
import {
  AttributeFilterConfig,
  EMPTY_GRID_FILTER,
  extractAttributesFilter,
  removeFieldFromFilter,
} from 'src/sections/shopping_lists/shoppingListProductMapper';
import { PunchoutOrderGuideItem } from 'src/types/punchout-order-guide/PunchoutOrderGuideItem';
import { normalizeNullOrEmptyFilters } from 'src/utils/normalizeNullOrEmptyFilters';

export { extractAttributesFilter };

export const applyPunchoutAttributesFilter = (
  items: PunchoutOrderGuideItem[],
  config: AttributeFilterConfig | null
): PunchoutOrderGuideItem[] => {
  if (!config?.attributes.length) {
    return items;
  }

  return items.filter((item) => {
    const attributes = item.attributes ?? [];

    if (config.operator === 'or') {
      return config.attributes.some((attribute) => attributes.includes(attribute));
    }

    return config.attributes.every((attribute) => attributes.includes(attribute));
  });
};

export const buildPunchoutOrderGuideProcessState = (dataState: State): State => ({
  ...dataState,
  filter:
    normalizeNullOrEmptyFilters(removeFieldFromFilter(dataState.filter, 'attributes')) ??
    EMPTY_GRID_FILTER,
});
